import { Skeleton } from 'antd';

const SkeletonComponent = ({ isPhone = false }: { isPhone?: boolean }) => (
    <div className={`table-list-skeleton ${isPhone ? 'table-list-skeleton-phone' : ''}`}>
        {[1, 2, 3].map((item) => (
            <div className="table-list-item-list" key={item}>
                <Skeleton active title={false} paragraph={{ rows: isPhone ? 8 : 6 }} />
            </div>
        ))}
    </div>
);

export default SkeletonComponent;
